// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"615":"8005daa9","814":"80a9b7c4","888":"f83cac8b"}[chunkId] + ".css";
};